module.exports = __webpack_public_path__ + "static/media/sleepyDragonFrame1.c67a65e6.png";